var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
        }
      }),
      _vm._v(" "),
      _vm.ruta_icono
        ? _c(
            "v-card",
            { attrs: { color: _vm.color } },
            [
              _c(
                "v-card-text",
                { staticClass: "p-0" },
                [
                  _c(
                    "v-img",
                    {
                      attrs: {
                        "aspect-ratio": 16 / 9,
                        src: _vm.ruta_icono,
                        contain: ""
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "lightbox black--text text-xs-center",
                          attrs: { "pa-2": "", column: "", "fill-height": "" }
                        },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { shrink: "" } }, [
                            _c("div", [_c("b", [_vm._v(_vm._s(_vm.titulo))])]),
                            _vm._v(" "),
                            _c("b", { staticStyle: { "font-size": "1.5em" } }, [
                              _vm._v(
                                _vm._s(
                                  this.detalle || this.detalle == 0
                                    ? this.detalle
                                    : "-"
                                )
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e3702a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3702a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/components/CuadroDetalle.vue
// module id = null
// module chunks = 